module.exports = __webpack_public_path__ + "static/media/Trust-Badge-4.d38b43fa.png";